export default __webpack_public_path__ + "static/media/q9_step1_2.addcbf0c.png";